const closeAfterSuccessfulLogin = async (to, from, next) => {
    if (to.query.closeAfterSuccessfulLogin === 'true') {
        window.close();
    } else {
        next();
    }
};

export default closeAfterSuccessfulLogin;
